import { createCRUDHook } from './createCRUDHook';
import { DraftPartChangeLogDto } from 'utils/models';
import { TBL_DRAFT_PART_MULTIPLIER } from './apiEndPoints';

const { Context, useManager, useConsumer } =
  createCRUDHook<DraftPartChangeLogDto>({
    entityName: 'DraftPartChangeLog',
    endpoint: TBL_DRAFT_PART_MULTIPLIER,
  });

export const DraftPartChangeLogContext = Context;
export const useDraftPartChangeLogManager = useManager;
export const useDraftPartChangeLog = useConsumer;
